import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import SearchField from "../SearchField"

export default function RandomPersonnelSearchFieldsObservable(): Observable<SearchField[]> {
  return ObservableFromFetch<SearchField[]>("RandomTest/GetSearchDropdowns")
}
